import { useGetPyqChallengeList } from "../hooks/useGetPyqChallengeList";
import { isEmpty } from "../../../../../../../custom_utilities/custom_useful_functions";
import images from "../../../../../../../utilities/images/images";
import "./PyqChallengeData.scss";
import usePyqRedux from "../hooks/usePyqRedux";
import { useNavigation } from "../../../../../../../hooks/useNavigation";

const PyqChallengeData = () => {
  const { data } = useGetPyqChallengeList();
  const { setDay } = usePyqRedux();
  const { navigateTo } = useNavigation();

  const pyqDailyChallenge = (day) => {
    setDay(day);
    navigateTo("/Pyq_dailyChallenge");
  };
  return (
    <div className="topicWiseWrapper">
      {!isEmpty(data) && data.length
        ? data.map((elem, index) => (
            <div
              key={index}
              className="daysBox"
              onClick={() =>
                !elem.lock
                  ? pyqDailyChallenge(elem.schedule)
                  : alert("Please Wait to Unlock")
              }
            >
              <div className="topicNameImg">
                <h5>{elem.schedule}</h5>
              </div>
              <div className="arrow">
                {elem.lock ? (
                  <img
                    className="lock_image"
                    src={images.locked_symbol}
                    alt="locked"
                  />
                ) : (
                  <img
                    className="arrow_image"
                    src={images.right_Ar}
                    alt="arrow"
                  />
                )}
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default PyqChallengeData;
